export const HOMEPAGE = "/";
export const SIGNUPPAGE = "/auth/signup";
export const LOGINPAGE = "/auth/login";
export const PROTECTEDPAGE = "/protected";
export const CURRENT_USER_PROFILE = "/profile";
export const CREATE_POST = "/post/create";
export const POST_PAGE = "/post/:postId";
export const FEED_PAGE = "/feed";
export const PROFILE_SETTINGS_PAGE = "/settings";
export const EDIT_POST = "/post/:postId/edit";
